import(/* webpackMode: "eager" */ "/home/runner/work/UllrWeb/UllrWeb/app/(public)/view/[sport]/areas/[areaId]/page.tsx");
